import React, { useEffect, useState } from 'react';
import Icon from '@app/components/Icon/index';
import { avatarSizes, AvatarSizesTypes } from '@app/components/Avatar/constants';

interface IReceivedData {
    size?: AvatarSizesTypes;
    imageType?: string;
    overrideUrl?: string;
    userId?: string;
    email?: string;
    className?: string;
    isDefaultIcon?: boolean;
}

export const AvatarComponent = (props: IReceivedData) => {
    const [avatar, setAvatar] = useState<string>('');
    const [isShowDefaultAvatar, setIsShowDefaultAvatar] = useState<boolean>(false);
    const [size, setSize] = useState<string>('avatar__avatar-small');

    useEffect(() => {
        // Priority
        // 1. override url
        // 2. userid and email
        // 3. userid
        // 4. imageType
        // 5. use the default set in state

        if (props.overrideUrl && props.overrideUrl !== '') {
            setAvatar(props.overrideUrl);
        } else if (props.userId && props.userId !== '' && props.email && props.email !== '') {
            setAvatar('/api/account/' + props.userId + '/i/' + props.email + '/' + 48);
        } else if (props.userId && props.userId !== '') {
            setAvatar('/api/account/' + props.userId + '/i');
        } else if (props.imageType === 'green' || props.imageType === 'blue') {
            setIsShowDefaultAvatar(true);
        }
        if (props.size) {
            setSize('avatar__avatar-' + props.size);
        }
    }, []);

    const noGravatarFound = () => {
        setIsShowDefaultAvatar(true);
    };
    const sizeObject = props.size ? avatarSizes[props.size] : {};

    return isShowDefaultAvatar ? (
        <Icon icon='accountCircleIco' className={`${props.className} ${!props.imageType && 'avatar__avatar-default'}`} {...sizeObject} />
    ) : (
        <div className='avatar'>
            <img id='profileAvatar' onError={noGravatarFound} className={`${props.className} ${size}`} src={avatar} alt='' />
        </div>
    );
};
